import {useHistory} from "react-router";
import {useState, useEffect, useContext} from "react";
import {IonGrid, IonRow, IonCol} from "@ionic/react";

// GraphQL
import {useLazyQuery, useQuery} from "@apollo/client";
import {
  GET_MY_AGENCY,
  GET_PAGINATED_CART_ITEM_QUERY,
} from "../../../graphql/queries/common.query";
import {GET_SERVICE_BY_SUB_SERVICE_TYPE} from "../../../graphql/queries/service.query";

// Custom Components
import Orders from "./Order";
import {AppButton, Breadcrumbs} from "../../../components";

// Config and other stuffs
import {AuthContext} from "../../../context/AuthContext";

// Custom CSS file
import "./attesa.style.css";
import {isAuthenticated} from "../../../lib/utils/auth.utils";
import {isDateExpired} from "../../../lib/utils/date-checker";

const PersonalAttesa = ({
  handleGoToNextPage,
}: {
  handleGoToNextPage?: (formFieldData: any) => void;
}) => {
  const history = useHistory();

  //
  const {cartList, isLoggedIn} = useContext(AuthContext);

  //
  const historySearch = history?.location?.search;
  const urlParams = new URLSearchParams(historySearch);

  const [serviceId, serviceType, masterId] = [
    urlParams.get("serviceId"),
    urlParams.get("serviceType"),
    urlParams.get("masterId"),
  ];

  const isSubService = serviceId && serviceType && masterId;

  const [cartItems, setCartItems] = useState<any[]>([]);

  const [agencyDetails, setAgencyDetails] = useState<any>({});

  if (isAuthenticated()) {
    useQuery(GET_MY_AGENCY, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setAgencyDetails(data.getMyAgency);
      },
    });
  }

  // Queries
  const [getSubServiceDetails] = useLazyQuery(GET_SERVICE_BY_SUB_SERVICE_TYPE, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const info = data.getServiceBySubServiceType.data;
      if (!info) return;

      setCartItems([{service: info}]);
    },
  });

  const [getPaginatedCartItems] = useLazyQuery(GET_PAGINATED_CART_ITEM_QUERY, {
    fetchPolicy: "network-only",
    onCompleted(data) {
      const info = data.getPaginatedCartItem.data;
      setCartItems(info);
    },
  });

  // App breadcrumb
  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Pratica in fase di completamento"},
  ];

  useEffect(() => {
    if (!isLoggedIn()) {
      return history.push("/login");
    }

    //
    if (isSubService) {
      getSubServiceDetails({
        variables: {masterId: parseInt(serviceId), serviceType},
      });
    } else {
      getPaginatedCartItems();
    }
  }, []);

  useEffect(() => {
    if (!isLoggedIn()) {
      return history.push("/login");
    }

    //
    getPaginatedCartItems();
  }, [cartList]);

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      {cartItems.length < 1 && (
        <>
          <div className="attesa-no-service-text">
            Nessun servizio selezionato
          </div>

          <AppButton
            onClick={() => {
              const searchBarInput = document.getElementById(
                "header-search-input"
              );

              if (searchBarInput) {
                searchBarInput?.click();
              }
            }}
          >
            Add Servizio
          </AppButton>
        </>
      )}

      {cartItems.length > 0 && (
        <IonGrid>
          {isDateExpired(agencyDetails?.client?.expiresAt) && (
            <IonRow>
              <IonCol>
                <span style={{color: "red", fontWeight: "bold"}}>
                  Attenzione, il documento di identità risulta essere scaduto.
                  Aggiornalo al piu presto nel tuo profilo personale
                </span>
              </IonCol>
            </IonRow>
          )}

          <Orders data={cartItems} handleGoToNextPage={handleGoToNextPage} />
        </IonGrid>
      )}
    </div>
  );
};

export default PersonalAttesa;
